var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStedentrip = function SvgIconStedentrip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon_stedentrip_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_stedentrip_svg__cls-1{fill:#4a4a4a}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9a3 3 0 1 1-3 3 3 3 0 0 1 3-3m0-1a4 4 0 1 0 4 4 4 4 0 0 0-4-4Z",
    className: "icon_stedentrip_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19h1a1 1 0 0 0 1-1V4c0-1-1-1-1 0v1h-2a6.6 6.6 0 0 0-.6-1.54 3.21 3.21 0 0 0-1-1.18A10.19 10.19 0 0 0 12.5 2V.73c0-1-1-1-1 0V2a11.22 11.22 0 0 0-2.16.29 3.81 3.81 0 0 0-.85 1.22L8 5H6V4c0-1-1-1-1 0v14a1 1 0 0 0 1 1h1v5h10M11 3h2a1.55 1.55 0 0 1 1.62.9A6.06 6.06 0 0 1 15 5H9s.17-.54.37-1A1.54 1.54 0 0 1 11 3Zm5 20h-2v-2h-1v2h-2v-2h-1v2H8v-4h8Zm2-5H6V6h12Z",
    className: "icon_stedentrip_svg__cls-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m13.61 12.91-1.11-1.12v-1.33A.47.47 0 0 0 12 10a.47.47 0 0 0-.46.46v1.66a.47.47 0 0 0 .36.45l1.05 1a.46.46 0 0 0 .65 0 .46.46 0 0 0 .01-.66Z",
    className: "icon_stedentrip_svg__cls-1"
  })));
};
export default SvgIconStedentrip;